var React = require('react');

function PaginationChevronSingle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.793 1.707 2.207.293 9.914 8l-7.707 7.707-1.414-1.414L7.085 8z","fillRule":"nonzero"}));
}

PaginationChevronSingle.defaultProps = {"viewBox":"0 0 10 16"};

module.exports = PaginationChevronSingle;

PaginationChevronSingle.default = PaginationChevronSingle;
